module.exports = "//public.getcloudapp.com/packs/media/images/branding-a66a039e030371fcc5b50b55d1ab426b.svg";